export default "__VITE_ASSET__BFhrPf4n__"